<form [formGroup]="craftForm">
  <div class="product-card border p-3 cursor-pointer disabled">
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center mb-1">
        <h5 class="fw-500 mb-0">{{ craftList()?.code }}</h5>
        <span class="badge bg-dark-subtle fw-500 ms-2 text-black">{{ CraftTypeEnum[craftList()?.type] }}</span>
      </div>
      <p class="text-muted small mb-2">{{ craftList()?.description ?? '' }}</p>
      <p class="text-muted small mb-0">{{ craftList()?.task?.taskCode ?? '' }}</p>
    </div>
  </div>

  <div class="mb-3">
    <label for="description" class="form-label">PO Description</label>
    <textarea
      formControlName="poDescription"
      id="description"
      class="form-control"
      rows="3"
      [required]="true"
      placeholder="Enter PO Description"
    ></textarea>
    @if (craftForm.get('poDescription')?.errors?.['required'] && craftForm.get('poDescription')?.touched) {
      <small class="text-danger">PO Description is required</small>
    }
  </div>

  <div class="mb-3">
    <!-- <label class="form-label">Draw Code</label>
  <ng-select class="ng-select-md" [appendTo]="'body'" placeholder="Select" formControlName="frequency">
    <ng-option value="daily">[Draw Code]</ng-option>
    <ng-option value="sunday">[Draw Code]</ng-option>
  </ng-select> -->
    <generic-dropdown
      [items]="drawCodeList()"
      [label]="'Draw Code'"
      [allowSearch]="true"
      [clearable]="true"
      [placeholder]="'Select Draw Code'"
      formControlName="drawCodeId"
    >
    </generic-dropdown>
  </div>
  <div class="d-flex align-items-center justify-content-between gap-3">
    <h4>Exclude From Global Markup</h4>
    <p-toggleswitch formControlName="excludeFromGlobalMarkup" />
  </div>
</form>
